module.exports = __webpack_public_path__ + "static/img/1.5318e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home-en/1.png
// module id = djE1
// module chunks = 0